import { WidgetType } from '../../core/template-definition.model';
import { WidgetTypeComponentMapType } from '../../core/widget-type-component-map-type';
import { ScBonusWidgetComponent } from '../sub-widget/bonus/bonus-pulse-widget.component';
import { ScOverallPulseWidgetComponent } from '../sub-widget/overall/overall-pulse-widget.component';
import { ScRanksPulseWidgetComponent } from '../sub-widget/rank/ranks-pulse-widget.component';
import { ScYourTeamWidgetComponent } from '../sub-widget/your-team/yourteam-pulse-widget.component';

export const widgetTypeComponentMap: WidgetTypeComponentMapType = {
    [WidgetType.SCORECARD_GRID]: null,
    [WidgetType.FYI_GRID]: null,
    [WidgetType.OVERALL_SCORE_GRID]: ScOverallPulseWidgetComponent,
    [WidgetType.RANKINGS_GRID]: ScRanksPulseWidgetComponent,
    [WidgetType.COMPENSATION_CONDITION]: null,
    [WidgetType.COMPENSATION_QUALIFIERS]: null,
    [WidgetType.COMPENSATION_MODIFIERS]: null,
    [WidgetType.COMPENSATION_BONUS]: ScBonusWidgetComponent,
    [WidgetType.METRIC_TREND_CHART]: null,
    [WidgetType.YOUR_TEAM]: ScYourTeamWidgetComponent,
};
